module.exports = __webpack_public_path__ + "static/media/blinko-black.994c5230.png";